export default {"src":"/_next/static/media/twitter.72512780.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};